"use client";
import { User } from "@/models/user";
import UserServices from "@/services/main/UserServices";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

type UseUserProps = {
  user?: User;
  options?: Omit<UseQueryOptions<User, unknown, User>, "queryKey" | "queryFn">;
};

export const useUserQuery = ({ user, options }: UseUserProps) => {
  return useQuery<User, unknown>({
    queryKey: ["user"],
    queryFn: async () => {
      const result = await UserServices.getMe();
      return result;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: Infinity,
    gcTime: Infinity,
    initialData: user,
    ...options,
  });
};
